import React, { FunctionComponent } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import './App.scss';

import Domain from './Domain/Domain';
import Home from './Home/Home';
import SiteHeader from './Layout/SiteHeader';

const LayoutWithHeader: FunctionComponent = ({ children }) => (
  <div>
    <Route path="/" component={SiteHeader} />
    {children}    
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Route exact path="/">
        <Redirect to="/domain" />
      </Route>

      <Switch>
        <LayoutWithHeader>
          <Route exact path="/domain" component={Domain} />
        </LayoutWithHeader>                
      </Switch>

      {/* <Redirect path="*" to="/domain" /> */}
    </BrowserRouter>
  )
}
export default App;
